import { createFileRoute } from "@tanstack/react-router";
import NameIndexPage from "@/site/pages/name-index";

export const Route = createFileRoute("/name/")({
  component: NameIndexPage,
});
